<template>
  <ul class="tab flex-row-center">
    <li
      v-show="detectTypes.includes(1)"
      class="flex-column-center"
      :class="{ active: active === 1, complete: active > 1 && active <= 3 }">
      <div>
        <p class="icon-wrap flex-row-center">
          <icon-white-pc class="icon-white-pc"></icon-white-pc>
          <span class="icon-correct" v-show="active !== 1 && active <= 3"></span>
        </p>
      </div>
      <p class="sub-text">网络与设备检测</p>
    </li>
    <li
      v-show="detectTypes.includes(2)"
      class="line-wrap flex-content-between"
      :class="{ 'active-line': active > 1 && active <= 3 }">
      <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
      <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
    </li>
    <li
      v-show="detectTypes.includes(2)"
      class="flex-column-center"
      :class="{ active: active === 2, complete: active === 3 }">
      <div>
        <p class="icon-wrap flex-row-center">
          <icon-white-camera class="icon-white-camera"></icon-white-camera>
          <span class="icon-correct" v-show="active === 3"></span>
        </p>
      </div>
      <p class="sub-text">摄像头检测</p>
    </li>
    <li
      v-show="detectTypes.includes(3)"
      class="line-wrap flex-content-between"
      :class="{ 'active-line': active === 3 }">
      <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
      <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
    </li>
    <li
      v-show="detectTypes.includes(3)"
      class="flex-column-center"
      :class="{ active: active === 3 }">
      <div>
        <p class="icon-wrap flex-row-center">
          <icon-white-micro class="icon-white-micro"></icon-white-micro>
        </p>
      </div>
      <p class="sub-text">麦克风检测</p>
    </li>
  </ul>
</template>

<script>
import IconWhitePc from '@/assets/svg/detect/icon_white_pc.svg'
import IconWhiteCamera from '@/assets/svg/detect/icon_white_camera.svg'
import IconWhiteMicro from '@/assets/svg/detect/icon_white_micro.svg'
import { mapState } from 'vuex'
export default {
  components: {
    IconWhitePc,
    IconWhiteCamera,
    IconWhiteMicro
  },
  props: {
    active: {
      type: Number
    }
  },
  computed: {
    ...mapState(['theme']),
    detectTypes() {
      const { openDetect, detectTypes } = this.theme
      return openDetect ? detectTypes.sort() : []
    }
  }
}
</script>

<style lang="scss" scoped>
  .tab {
    margin-top: 27px;
    margin-left: -30px;
  }
  .icon-wrap {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #D1D1D1;
  }
  .icon-white-pc {
    width: 24px;
    height: 20px;
  }
  .icon-white-camera {
    width: 20px;
    height: 25px;
  }
  .icon-white-micro {
    width: 18px;
    height: 25px;
  }
  .sub-text {
    font-weight: 400;
    margin-top: 10px;
  }
  .line-wrap {
    width: 120px;
    margin: -25px 28px 0 28px;
    span {
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background-color: #D1D1D1;
    }
  }
  div {
    border: 2px dotted rgba(0, 0, 0, 0);
    border-radius: 50%;
    padding: 6px;
  }
  .active {
    div {
      border: 2px dotted #3090FF;
    }
    .icon-wrap {
      background-color: #3090FF;
    }
    .sub-text {
      color: #3090FF;
    }
  }
  .active-line {
    span {
      background-color: #3090FF;
    }
  }
  .complete {
    .icon-wrap {
      position: relative;
      background-color: #3090FF;
    }
    .sub-text {
      color: #3090FF;
    }
    .icon-correct {
      position: absolute;
      left: 32px;
      bottom: -2px;
      width: 22px;
      height: 23px;
      background: url("~@/assets/images/detect/icon-correct.png") center / cover no-repeat;
    }
  }
</style>
